<template>
	<div>
		<egranty-section-divider
			:text="'Nazwa konkursu: ' + offerData.publicContestName"
			icon="assessment"
			:show-print-info="!offerData.sendDate"
		></egranty-section-divider>
		<br>
		<v-layout row>
			<v-flex xs12 md4>
				<v-card style="margin: 10px" class="offer-card">
					<v-card-title class="blue white--text">
						<h3>Oferta</h3>
					</v-card-title>
					<v-card-text>
						<display-text-component
							:flex="'full-width'"
							label="Numer"
							:value="offerData.offerCode"/>
						<display-text-component
							:flex="'full-width'"
							label="Suma kontrolna"
							:value="offerData.controlSum"/>
						<display-text-component
							:flex="'full-width'"
							label="Wersja"
							:value="offerData.offerVersion"/>
						<display-text-component
							:flex="'full-width'"
							class="no-print"
							label="Nazwa"
							:value="offerData.title"/>
						<display-text-component v-if="offerData.sendDate !== null"
							:flex="'full-width'"
							label="Data wysłania"
							:value="offerData.sendDate"/>
						<display-text-component
							:flex="'full-width'"
							label="Oferta wspólna"
							:value="offerData.mutualOffer ? 'TAK' : 'NIE'"/>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 md4>
				<v-card style="margin: 10px">
					<v-card-title style="background-color: #0075e2; color: #fff">
						<h3>Projekt</h3>
					</v-card-title>
					<v-card-text>
						<display-text-component
							class="modular"
							:flex="'reversed'"
							label="Modułowy"
							:value="contestConfiguration.numberOfModules > 1 ? 'TAK' : 'NIE'"/>
						<display-text-component v-if="contestConfiguration.numberOfModules > 1"
							class="modular"
							:flex="'reversed'"
							label="Liczba modułów"
							:value="contestConfiguration.numberOfModules"/>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 md4>
				<v-card style="margin: 10px" class="project-card">
					<v-card-title style="background-color: #0075e2; color: #fff">
						<h3>Wnioskowana kwota dotacji</h3>
					</v-card-title>
					<v-card-text>
						<div
							v-for="i in (contestConfiguration.numberOfModules > 1 ? contestConfiguration.numberOfModules : 0)"
							:key="i">
							<display-text-component
								:label="'Moduł nr ' + i"
								:value="formatMoney(offerData.stepsConstantData[i-1].requestedDotation) + ' PLN'"/>
						</div>
						<v-divider v-if="contestConfiguration.numberOfModules > 1"
							style="margin-top: 5px; margin-bottom: 5px"/>
						<display-text-component
							label="Łącznie"
							:value="totalRequestedDotation +  ' PLN'"/>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import DisplayTextComponent from "./DisplayTextComponent";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import {Numbers} from "../../../../utils/Numbers";

	export default {
		name: "ContestOfferSummaryHeader",
		components: {EgrantySectionDivider, DisplayTextComponent},

		mixins: [Numbers],

		computed: {
			totalRequestedDotation: function () {
				let total = 0;
				this.offerData.stepsConstantData.forEach(stepConstantData => {
					total += parseFloat(stepConstantData.requestedDotation);
				});
				return Numbers.methods.formatMoney(total);
			},
		},

		props: {
			contestConfiguration: Object,
			offerData: Object,
		}
	};
</script>

<style scoped>

</style>